// extracted by mini-css-extract-plugin
module.exports = {"productInfo":"ordersAdminTableColumns_productInfo__25Fhy","productImage":"ordersAdminTableColumns_productImage__2LqcZ","productName":"ordersAdminTableColumns_productName__2D_c2"};